/*
 * ===============================================================================================================
 *                                Copyright 2025, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme: Theme) => ({
  chip: {
    margin: theme.spacing(0.5),
    backgroundColor: theme.palette.primary.main,
  },
  root: {
   
  },
  editButton: {
    height: theme.spacing(5),
    marginTop: theme.spacing(2),
    marginRight: theme.spacing(4),
  },
  entitlementsWrap: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(5),
  },
}));
